import type { EntityListOfUserListItemDto } from "Infrastructure/Api/Api";
import { getUsers } from "Infrastructure/Api/Api";
import {
  type ApiCallError,
  processResponse,
} from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";
import { UserKeys } from "./userKeys";

interface UseUsersQueryOptions {
  offset?: number;
  limit?: number;
}

export const useUsersQuery = ({
  offset = 0,
  limit = 100,
}: UseUsersQueryOptions = {}) => {
  return useQuery<EntityListOfUserListItemDto, ApiCallError>({
    queryKey: UserKeys.users(offset, limit),
    queryFn: processResponse(({ signal }) =>
      getUsers(offset, limit, { signal }),
    ),
  });
};
